module.exports = __webpack_public_path__ + "img/capsules-mobile.6751529c.png";